var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50653 24.2948L2.3335 25.6666L3.70527 19.4935C2.82984 17.8565 2.3335 15.9862 2.3335 13.9999C2.3335 7.55659 7.55684 2.33325 14.0002 2.33325C20.4434 2.33325 25.6668 7.55659 25.6668 13.9999C25.6668 20.4432 20.4434 25.6666 14.0002 25.6666C12.0139 25.6666 10.1436 25.1703 8.50653 24.2948ZM8.16683 13.9999C8.16683 17.2216 10.7785 19.8333 14.0002 19.8333C17.2218 19.8333 19.8335 17.2216 19.8335 13.9999H17.5002C17.5002 15.933 15.9332 17.4999 14.0002 17.4999C12.0671 17.4999 10.5002 15.933 10.5002 13.9999H8.16683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.2ad78948dfa61569eafbe7333beae3d9.svg";
export { ForwardRef as ReactComponent };